import React from 'react';
import PropTypes from 'prop-types';
import { get, reduce } from 'lodash';

import { UrlService } from '@sm360/widget-commons-core-services';
import { ConfigsContainer, ConfigsModel } from '@sm360/widget-commons-configs';
import { CatalogModelSummary } from '@sm360/widget-commons-tiles';

import Rebate from './sections/Rebate.jsx';
import PriceDescription from './sections/PriceDescription.jsx';
import PaymentInformation from './sections/PaymentInformation.jsx';
import Disclaimer from './sections/Disclaimer.jsx';

import './CatalogTile.scss';

const CatalogTile = ({ model, buildAndQuoteUrl, selectedPurchaseMethod, configs, onClick, displayCreditRate }) => {
    // TODO remove hard coded image url and hard coded TPS
    const buildAndQuoteUrlParams = [
        {
            name: 'MODEL',
            value: 'model.name',
        },
        {
            name: 'MAKE',
            value: 'make.name',
        },
        {
            name: 'BODY_STYLE_CODE',
            value: 'bodyStyle.slug',
        },
    ];

    const modelImage = model.multimedia.exterior.side;
    const modelDisclaimer = model.multimedia.pictureDisclaimer;

    // TODO Add image XMS for no-photo and link to it
    const imageUrl = modelImage
        ? `${configs.source.image}/ir/w450h215c/images/newcar/${modelImage}`
        : `${configs.source.image}/ir/w450h215c/images/widget/showroom/asset/non-photo.png`;

    const pictureDisclaimer = !!modelDisclaimer && <p className="vehicle-image-status is-light">{modelDisclaimer}</p>;

    const url = reduce(
        buildAndQuoteUrlParams,
        (previousUrl, urlParameter) => {
            const parameterValue = get(model, urlParameter.value);
            return UrlService.replaceParamWithValue(previousUrl, urlParameter.name, parameterValue);
        },
        buildAndQuoteUrl
    );

    // As '.' in model string seems to cause issue to access build and quote, we remove it (STS-1999)
    const slashIndexURL = url.lastIndexOf('/');
    const URLSubstring1 = url.slice(0, slashIndexURL);
    let URLSubstring2 = url.slice(slashIndexURL, url.length);
    if (URLSubstring2 && URLSubstring2.indexOf('.') > -1) {
        URLSubstring2 = URLSubstring2.replace('.', '');
    }
    const formattedURL = `${URLSubstring1}${URLSubstring2}`;

    return (
        <div className="vehicle-tile">
            <a href={formattedURL} onClick={onClick} role="button">
                <div className="vehicle-item">
                    <div className="vehicle-image">
                        <img alt={imageUrl} src={imageUrl} />
                    </div>
                    <div className="vehicle-info">
                        {pictureDisclaimer}
                        <Rebate incentives={model.enhancedPricing.bestIncentives} />

                        <PriceDescription
                            modelDescription={model.model.name}
                            modelBodyStyle={model.bodyStyle.name}
                            price={model.price}
                        />
                        <PaymentInformation
                            purchaseTerm={model.getFinancingByPurchaseMethod(selectedPurchaseMethod)}
                            purchaseMethod={model.getPurchaseMethodToDisplay(selectedPurchaseMethod)}
                            costOfCredit={model.costOfCredit}
                            displayCreditRate={displayCreditRate}
                        />
                    </div>
                </div>
            </a>
            <Disclaimer model={model} />
        </div>
    );
};

CatalogTile.defaultProps = {
    displayCreditRate: false,
};

CatalogTile.propTypes = {
    model: PropTypes.instanceOf(CatalogModelSummary).isRequired,
    selectedPurchaseMethod: PropTypes.number.isRequired,
    buildAndQuoteUrl: PropTypes.string.isRequired,
    configs: PropTypes.instanceOf(ConfigsModel).isRequired,
    onClick: PropTypes.func,
    displayCreditRate: PropTypes.bool,
};

CatalogTile.displayName = 'Tile-A.CatalogTile';

export { CatalogTile };

export default ConfigsContainer(CatalogTile);
